/**
 * 计划性线索总路由
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("plannedCluesRouterModule", ["tracingMonitoringRouterModule"]).config(["$stateProvider",
    function($stateProvider) {
        $stateProvider.
        state("front.plan.realtimeclues.plannedclues.recentpolicy", {
            url: '/recentpolicy', //近期政策
            views: {
                "main@front.plan.realtimeclues.plannedclues": {
                    templateUrl: "./planningCenter/realTimeClues/plannedClues/recentPolicy/recentPolicy_tpl.html",
                    controller: "recentPolicyController"
                }
            }
        }).
        state("front.plan.realtimeclues.plannedclues.todayinhistory", {
            url: '/todayinhistory', //历史的今天
            views: {
                "main@front.plan.realtimeclues.plannedclues": {
                    templateUrl: "./planningCenter/realTimeClues/plannedClues/todayInHistory/todayInHistory_tpl.html",
                    controller: "todayInHistoryController"
                }
            }
        }).
        state("front.plan.realtimeclues.plannedclues.recentmeeting", {
            url: '/recentmeeting', //近期会议
            views: {
                "main@front.plan.realtimeclues.plannedclues": {
                    templateUrl: "./planningCenter/realTimeClues/plannedClues/recentMeeting/recentMeeting_tpl.html",
                    controller: "recentMeetingCtrl"
                }
            }
        });
    }
]);